<ng-template #brandLogo>
  <img
    [src]="tenantConfigService.desktopLogoUrl"
    [alt]="tenantConfigService.config.productName + ' logo'"
    role="img"
    [attr.aria-label]="tenantConfigService.config.productName + ' logo'"
    loading="lazy"
  />
</ng-template>

<header
  *ngIf="tenantConfigService.config.brandId === 'heron'">
  <div class="heron-header-img-wrapper">
    <ng-container *ngTemplateOutlet="brandLogo"></ng-container>
    <ng-container *ngIf="tenantConfigService.config.brandId === 'heron'">
      <div class="logo-separator"></div>
      <img
        src="assets/img/B_Corp_logo.svg"
        alt="B-Corp logo"
        role="img"
        aria-label="B-Corp logo"
        loading="lazy"
        class="bcorp_logo"
      />
    </ng-container>
  </div>
</header>

<section [ngClass]="!showTimeLine ? 'content' : 'content-with-timeline'">
  <div *ngIf="tenantConfigService.config.brandId !== 'heron'" class="brand-logo">
    <ng-container *ngTemplateOutlet="brandLogo"></ng-container>
  </div>
  <ng-container *ngIf="showTimeLine">
    <hfc-shared-timeline [timeLineContent]="timeLineContent"></hfc-shared-timeline>
  </ng-container>
  <div class="content-wrapper" [class.terms-conditions-width]="stepNumber === 3">
    <ng-content></ng-content>
    <footer *ngIf="showButtons" [class.footer-margin]="stepNumber < 2">
      <ng-container *ngIf="nextLabel">
        <hfc-button
          type="primary"
          [isLoading]="(signUpStateService.updateIsSubmitting$ | async) === true"
          [disabled]="nextDisabled"
          (click)="nextAction.emit()"
        >{{ nextLabel }}
        </hfc-button>
      </ng-container>
      <ng-container *ngIf="backLabel">
        <hfc-button type="secondary" (click)="backAction.emit()" [disabled]="currentStep === 1"
        >{{ backLabel }}
        </hfc-button>
      </ng-container>
    </footer>
  </div>

  <ng-container *ngIf="showCopyright">
    <div *ifMedia="'desktop'" class="copyright text-grey60">
      © {{ currentYear }} {{ tenantConfigService.config.companyName }} All Rights Reserved
    </div>
  </ng-container>
</section>
